<skypro-communication-message
  [message]="thread"
  [isActive]="isHighlighted"
  [canEdit]="canEdit"
  [canDelete]="canDelete"
  [canPin]="canPin"
  [canHide]="canHide"
  [canClose]="canClose && thread.status === ThreadStatus.open"
  [isDeleted]="thread.isDeleted"
  [isPinned]="thread.isPinned"
  [isHidden]="thread.isHidden"
  [hasActions]="hasActions"
  (delete)="delete.emit()"
  (edit)="edit.emit()"
  (close)="close.emit()"
  (pin)="pin.emit()"
  (unpin)="unpin.emit()"
  (hide)="hide.emit()"
  (show)="show.emit()"
  class="root"
>
  <ng-template skyproCommunicationLike>
    <ng-content></ng-content>
  </ng-template>
  @if (thread.messages.length > 0) {
  <ds-link data-test="комментарии">
    <button class="comments-link" (click)="toggleSelect()">
      <div class="avatar-preview-list">
        @for (author of (thread.messages | lastNUniqAuthors:3); track author) {
        <vim-core-user-avatar
          class="avatar-preview"
          [user]="author.user"
          [avatarUrl]="author.avatarUrl"
          [size]="24"
        ></vim-core-user-avatar>
        }
      </div>
      <span class="comments-link-text" [class.-expanded]="isExpandedMessages">
        {{ 'skyproCommunications.replyCount' | transloco: {count: thread.messages.length} }}
        <ds-icon-arrow-right-2
          size="s"
          class="expander-arrow"
          [class.-expanded]="isExpandedMessages"
        ></ds-icon-arrow-right-2>
      </span>
    </button>
  </ds-link>
  } @if (!readOnly) {
  <ds-link data-test="ответить в тред">
    <button class="answer-link" (click)="replyClicked.emit()">
      <span class="answer-link-text">{{ 'skyproCommunications.reply' | transloco }}</span>
    </button>
  </ds-link>
  }
</skypro-communication-message>
